import { getBackOfficeEntityDataSource } from './index';
import { IInwinkEntityDataSourceOptions } from '@@api/base/datasource';

export function changelogDataSource(options?: IInwinkEntityDataSourceOptions) {
    return getBackOfficeEntityDataSource<any>("", "changelog", "Changelog", options);
}
